import * as React from 'react'
import { Link } from 'gatsby'

import logo from '../../static/img/99sense-logo.svg'
import facebook from '../../static/img/facebook.svg'
import instagram from '../../static/img/instagram.svg'
import linkedin from '../../static/img/linkedin.svg'

import telephone from '../../static/img/telephone.svg'
import email from '../../static/img/email.svg'
import location from '../../static/img/location.svg'

const Footer = class extends React.Component {
  render() {
    return (
      <footer className="footer footer-shadow">
        <div className="content has-text-left">
          <div className="container">
            <div style={{ maxWidth: '100vw' }} className="columns is-8">
              <div className="column">
                <section>
                  <h4 className="is-uppercase">About</h4>
                  <p>
                    Life's experiences, in particular social and economic
                    experiences (more evident over the last 2 decades in South
                    Africa), have shown us that the future doesn't guarantee a
                    better life and if we want a better life we have to
                    completely be committed in making that happen.
                  </p>
                  <img
                    src={logo}
                    alt="99Sense - Loyalty Starts At Home"
                    width="300px"
                  />
                </section>
              </div>
              <div className="column">
                <section className="menu">
                  <h4 className="is-uppercase">Menu</h4>
                  <ul className="menu-list">
                    <li>
                      <Link className="navbar-item" to="/">
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/about">
                        About
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/blog">
                        Blog
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/contact">
                        Contact Us
                      </Link>
                    </li>
                    <li>
                      <a
                        className="navbar-item"
                        href="/admin/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Admin
                      </a>
                    </li>
                  </ul>
                </section>
              </div>
              <div className="column">
                <section>
                  <h4 className="is-uppercase">Contact</h4>
                  <ul className="menu-list">
                    <li>
                      <img src={telephone} alt="Telephone" width="30px" />
                      0318271777
                    </li>
                    <li>
                      <a
                        href="mailto:admin@99sense.co.za"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={email} alt="Email" width="30px" />
                        admin@99sense.co.za
                      </a>
                    </li>
                    <li>
                      <img src={location} alt="Location" width="30px" />
                      27 Bishops Road, Windermere, Durban 4001
                    </li>
                  </ul>
                </section>
              </div>
              <div className="column">
                <section>
                  <h4 className="is-uppercase">Social</h4>
                  <ul className="menu-list">
                    <li>
                      <a
                        href="https://www.facebook.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={facebook} alt="Facebook" width="50px" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={instagram} alt="Instagram" width="50px" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.linkedin.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={linkedin} alt="LinkedIn" width="50px" />
                      </a>
                    </li>
                  </ul>
                </section>
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
